var BlockCompiler = require("../../compiler/compiler.js");
var CBlockType = require("../../compiler/types.js");
var CoreFunctions = require("../../compiler/corefunc.js");

BlockCompiler.defineBlock("looks_hide", {
  type: CBlockType.COMMAND,
  func: function (utils) {
    return `sprite.hidden = true;`;
  },
});
